export function Pulse() {
  return (
    <span className="relative inline-flex h-4 w-4" aria-hidden="true">
      <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent/60" />
      <span className="relative inline-flex h-4 w-4 rounded-full bg-accent" />
    </span>
  );
}
